import React from 'react';

import { Tooltip as CastlecraftTooltip } from 'castlecraft-ui';

const Tooltip = ({ content, children }) => {
  return <CastlecraftTooltip content={content}>{children}</CastlecraftTooltip>;
};

export default Tooltip;
